module.exports = {
  bpmnImporter: [ 'type', require(43) ]
};